module.exports = __webpack_public_path__ + "img/car600.78b25084.png";